// ======================================================================
// File: src/modules/ppe/pages/procurement/grn/services/grnService.js
// Module: PPE → Procurement → GRN
//
// Purpose:
// - Axios based service layer for GRN module
// - All backend API communication for GRN
// - Follows exact pattern of indentService.js
//
// Author: Auto-generated based on project architecture
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/grn";

const grnService = {

  // ----------------------------------------------------------
  // CREATE GRN HEADER
  // ----------------------------------------------------------
  createGRN: async (payload) => {
    const response = await axiosClient.post(BASE_URL, payload);
    return response.data;
  },

  // ----------------------------------------------------------
  // ADD GRN LINE
  // ----------------------------------------------------------
  addGRNLine: async (grnId, payload) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${grnId}/lines`,
      payload
    );
    return response.data;
  },

  // ----------------------------------------------------------
  // SUBMIT GRN
  // ----------------------------------------------------------
  submitGRN: async (grnId) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${grnId}/submit`
    );
    return response.data;
  },

  // ----------------------------------------------------------
  // APPROVE GRN
  // ----------------------------------------------------------
  approveGRN: async (grnId) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${grnId}/approve`
    );
    return response.data;
  },

  // ----------------------------------------------------------
  // POST GRN (Inventory Posting)
  // ----------------------------------------------------------
  postGRN: async (grnId) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${grnId}/post`
    );
    return response.data;
  },

  // ----------------------------------------------------------
  // CANCEL GRN
  // ----------------------------------------------------------
  cancelGRN: async (grnId, reason) => {
    const response = await axiosClient.post(
      `${BASE_URL}/${grnId}/cancel`,
      { reason }
    );
    return response.data;
  },

  // ----------------------------------------------------------
  // GET GRN LIST
  // ----------------------------------------------------------
  getGRNList: async (params = {}) => {
    const response = await axiosClient.get(BASE_URL, {
      params,
    });
    return response.data;
  },

  // ----------------------------------------------------------
  // GET GRN DETAIL
  // ----------------------------------------------------------
  getGRNById: async (grnId) => {
    const response = await axiosClient.get(
      `${BASE_URL}/${grnId}`
    );
    return response.data;
  },

// ----------------------------------------------------------
// SUBMIT FOR APPROVAL
// ----------------------------------------------------------
submitForApproval: async (grnId) => {
  const response = await axiosClient.post(
    `${BASE_URL}/${grnId}/submit-for-approval`
  );

  return response.data;
},
};


export default grnService;
